import { createContext, useState } from "react"
import { Outlet } from "react-router-dom"
import { TenantProfile } from "@hydrologiq/gql-experience/graphql"

type ContextState = {
  profile: TenantProfile
  setProfile: (profile: TenantProfile) => void
}
export const ProfileContext = createContext<ContextState | undefined>(undefined)

export const ProfileProvider = ({ children, profile }: { children?: React.ReactNode; profile?: TenantProfile }) => {
  const [profileState, setProfileState] = useState<TenantProfile>(profile ?? TenantProfile.FuelProducer)
  const value = {
    profile: profileState,
    setProfile: (profile: TenantProfile) => setProfileState(profile),
  }

  return <ProfileContext.Provider value={value}>{children ? children : <Outlet />}</ProfileContext.Provider>
}
